import React from 'react';
import Header from '../Components/Header';

const About = () => {
  return <Header>About</Header>;
};

export default About;
